import { darkTheme, lightTheme } from '@getgo/chameleon-core';
export const HEX_PREFIX = '#';
export const THEME_DARK = 'theme-dark';
export const THEME_LIGHT = 'theme-light';
export const TOKEN_PRIMARY_TEXT = 'text-01';
export const TOKEN_INVERSE_TEXT = 'text-04';
export const TOKEN_BACKGROUND = 'ui-background';
export const WCAG_AA_RATIO = 7;
export const MINIMAL_RATIO = 2.5;
export const luminance = (r, g, b) => {
    const a = [r, g, b].map(v => {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
};
export const contrast = (color, backgroundColor) => {
    const lum1 = luminance(color.r, color.g, color.b);
    const lum2 = luminance(backgroundColor.r, backgroundColor.g, backgroundColor.b);
    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
};
export const convertToRGB = (hex) => {
    const bigint = parseInt(hex.substring(hex.indexOf(HEX_PREFIX) + 1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return {
        r,
        g,
        b,
    };
};
export const convertToRBGA = (hex, alpha, backgroundHex) => {
    const rgb = convertToRGB(hex);
    const background = convertToRGB(backgroundHex);
    rgb.r = Math.floor(rgb.r * alpha + background.r * (1 - alpha));
    rgb.g = Math.floor(rgb.g * alpha + background.g * (1 - alpha));
    rgb.b = Math.floor(rgb.b * alpha + background.b * (1 - alpha));
    return rgb;
};
export const convertToHex = (color) => `#${((1 << 24) + (color.r << 16) + (color.g << 8) + color.b).toString(16).slice(1)}`;
export const isDarkTheme = (element) => {
    let darkTheme = false;
    if (element) {
        const light = element.closest(`.${THEME_LIGHT}`);
        const dark = element.closest(`.${THEME_DARK}`);
        if (light && dark) {
            darkTheme = !!(dark.compareDocumentPosition(light) & Node.DOCUMENT_POSITION_PRECEDING);
        }
        else {
            darkTheme = !!dark;
        }
    }
    else {
        darkTheme = !!document.querySelector(`.${THEME_DARK}`);
    }
    return darkTheme;
};
export const getDesignToken = (token, element) => isDarkTheme(element) ? darkTheme[token] : lightTheme[token];
export const shouldInvertText = (colorToken, backgroundColor, inverseColorToken, element) => {
    let invert = false;
    if (backgroundColor) {
        const mainContrast = contrast(convertToRGB(getDesignToken(colorToken, element)), convertToRGB(backgroundColor));
        const inverseContrast = contrast(convertToRGB(getDesignToken(inverseColorToken, element)), convertToRGB(backgroundColor));
        // try to keep the main color as much as possible unless inverse is better
        if (mainContrast > WCAG_AA_RATIO) {
            invert = false;
        }
        else if (inverseContrast > WCAG_AA_RATIO) {
            invert = true;
        }
        else if (mainContrast > inverseContrast || mainContrast > MINIMAL_RATIO) {
            invert = false;
        }
        else {
            invert = inverseContrast > mainContrast;
        }
    }
    return invert;
};
export const lighten = (color, amount) => {
    const rgb = convertToRGB(color);
    const percentage = 1 + amount / 100;
    rgb.r = Math.min(Math.round(percentage * rgb.r), 255);
    rgb.g = Math.min(Math.round(percentage * rgb.g), 255);
    rgb.b = Math.min(Math.round(percentage * rgb.b), 255);
    return convertToHex(rgb);
};
export const darken = (color, amount) => {
    const rgb = convertToRGB(color);
    const percentage = 1 - amount / 100;
    rgb.r = Math.round(rgb.r * percentage);
    rgb.g = Math.round(rgb.g * percentage);
    rgb.b = Math.round(rgb.b * percentage);
    return convertToHex(rgb);
};
//# sourceMappingURL=colors.js.map